/** Форма слова по числу: `pluralRu(3, ["доступ", "доступа", "доступов"])` → «доступа». */
export function pluralRu(count: number, [one, few, many]: readonly [string, string, string]): string {
  const mod10 = Math.abs(count) % 10;
  const mod100 = Math.abs(count) % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

const dayMonthFormat = new Intl.DateTimeFormat("ru", { day: "numeric", month: "long" });

/** Дата без года в часовом поясе пользователя: «8 октября». */
export function formatDayMonth(date: Date): string {
  return dayMonthFormat.format(date);
}
